var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{staticClass:"mx-0 my-0",attrs:{"rounded":"sm","variant":"light"}},[_c('img',{staticStyle:{"margin-right":"8px","margin-left":"8px"},attrs:{"width":"20px","src":_vm.sessionIconSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }